<div class="row mt-24">
  <div class="col-12" data-testid="tmt-erp-outbound-filter-modal-report-list">
    <app-tmt-erp-outbound-report-grouped-list/>
  </div>
</div>
